import "./App.css";
import Routers from "./routers";  
import GlobalStyle from "./styles";

function App() {
  return (
    <div>
      <GlobalStyle />
      <Routers />
    </div>
  );

}

export default App;
